import { render } from "./offset_slider.vue?vue&type=template&id=71b5e8f8&scoped=true"
import script from "./offset_slider.vue?vue&type=script&lang=js"
export * from "./offset_slider.vue?vue&type=script&lang=js"

import "./offset_slider.vue?vue&type=style&index=0&id=71b5e8f8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71b5e8f8"]])

export default __exports__